import { keyBy } from 'lodash';
import { useQuery } from '@tanstack/react-query';
import { getTenantGroups } from 'Services';
import { RQ_TENANT_GROUPS } from 'Utils';

type Props = {
    disable?: boolean;
};

const useGetTenantGroups = ({ disable }: Props) => {
    return useQuery([RQ_TENANT_GROUPS], getTenantGroups, {
        enabled: !disable,
        select: (data) => {
            return {
                original: data,
                hashmap: keyBy(data, 'id')
            } as CustomTenantGroupsResponse;
        }
    });
};

export default useGetTenantGroups;
